var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-container"},[_c('iframe',{staticClass:"chat-iframe",attrs:{"src":"http://chatbi.jinghongda.net:1357/chat/e4ac67cd1be89c9d?mode=mobile","frameborder":"0","allow":"microphone"}})])
}]

export { render, staticRenderFns }